<template>
    <v-container>
        <v-row v-for="(users, value) in userListGrouped" :key="value">
            <label class="font-weight-thin display-1">Maschinenring - {{toProvince(value)}}</label>
            <v-container>
                <v-row>
                    <v-col cols="12" md="4" lg="4" v-for="user in users" :key="user.user_id">
                        <UserCard :user="user"></UserCard>
                    </v-col>
                </v-row>
            </v-container>
        </v-row>

        <v-btn fab dark large bottom right fixed color="green" :to="{name: 'UserAdd'}">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
    import {Provinces, Roles, Utils} from '../components/_helpers';
    import UserCard from '../components/detail/user/UserCard';

    export default {
        name: 'Users',
        components: {
            UserCard
        },
        computed: {
            userProfile() {
                return this.$store.state.user.userProfile
            },
            userListGrouped() {
                // Group user-list per province and return a Map<Province,[UserProfile]>
                let grouped = Utils.groupBy(this.$store.state.user.userList, 'province')

                // Filter map when user does not belong to SUPERADMIN-role
                if (this.userProfile && this.userProfile.role !== Roles.ROLE_1.value) {
                    let result = {}

                    // Return only those users which belong to the same province
                    let userList = grouped[this.userProfile.province]

                    // Return only those users which do not belong to an SUPERADMIN-role
                    if (userList) {
                        userList = userList.filter(user => {
                            return user.role !== Roles.ROLE_1.value
                        })
                    }

                    result[this.userProfile.province] = userList

                    return result
                }

                return grouped
            }
        },
        methods: {
            toProvince(value) {
                let province = Provinces.itemByValue(value)
                return province ? province.text : 'No'
            }
        },
        mounted() {
            this.$store.dispatch('getUsers')
        }
    };
</script>

<style>
    /* empty */
</style>
